import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { StudentAnalysisAPIServiceV2 } from '@protos/analysis_management/analysis.student.apis_connect';
import { ResponseStatusCodeFunction, lmsTransport, lmsTransportWithLogoutHandler } from './transports';

export const StudentAnalysisAPIServiceV2Client = createPromiseClient(
  StudentAnalysisAPIServiceV2,
  lmsTransport
);
//StudentAnalysisAPIServiceV2
export const useStudentAnalysisAPIServiceV2ClientWithStatusCodeHandler = (options: Partial<ConnectTransportOptions>, responseStatusCodeFunction: ResponseStatusCodeFunction) => createPromiseClient(
  StudentAnalysisAPIServiceV2,
  lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
);
